module.exports = __webpack_public_path__ + "static/media/slide-mobile-3.e8d16977.png";